import { VirtualRoomRouterStoreSelectors } from '@era/stores';
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromCurtain from './curtains.reducer';

export interface CurtainState {
  curtains: fromCurtain.CurtainState;
}

export const reducers: ActionReducerMap<CurtainState> = {
  curtains: fromCurtain.curtainsReducer,
};

export const selectCurtainState = createFeatureSelector<fromCurtain.CurtainState>(fromCurtain.inRoomCurtainsFeatureKey);

export const selectCurtainEntities = createSelector(selectCurtainState, fromCurtain.selectCurtainEntities);

export const selectCurrentCurtains = createSelector(
  selectCurtainEntities,
  VirtualRoomRouterStoreSelectors.selectLocation,
  VirtualRoomRouterStoreSelectors.selectRoom,
  (entities, location: string, room: string) => {
    return entities[fromCurtain.selectCurtainId(location, room)];
  }
);
